module.exports = __webpack_public_path__ + "img/img_whenIsUseful2.839ada13.png";